import { useSelector } from 'react-redux';

import { isSmUsMri, isUs } from '@discover-frontend/utils';
import { mapMyCompanyFusions } from './mapMyCompanyFusions';

export const useMRISimmons = () => {
  const myCompany = useSelector((state: any) => state.myCompany);

  const { isMriSimmonsActivated } = mapMyCompanyFusions(
    myCompany?.data?.fusions
  );

  return {
    isMriSimmonsActivated: isMriSimmonsActivated && (isUs() || isSmUsMri()),
  };
};
